import { CryptoUtils, LocalAddress } from 'loom-js';

/**
 * Generate key pair.
 * @return key pair.
 */
const generateKeyPair = async function() {
  const privateKey = CryptoUtils.generatePrivateKey();
  const publicKey = CryptoUtils.publicKeyFromPrivateKey(privateKey);
  const retObj = {
    privateKey: CryptoUtils.Uint8ArrayToB64(privateKey),
    publicKey: CryptoUtils.Uint8ArrayToB64(publicKey),
    publicAddress: LocalAddress.fromPublicKey(publicKey).toString()
  };
  return retObj;
};

export { generateKeyPair };
